"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditModeTemplate = void 0;
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
var getFeedbackFor = function (validationResults) {
    if (validationResults === void 0) { validationResults = []; }
    return validationResults.map(function (result, index) {
        return typeof result !== "boolean" && result.message ? (React.createElement(components_1.GKFormFeedback, { key: "feedback-" + index, valid: result.isValid }, result.message)) : null;
    });
};
var EditModeTemplate = function (_a) {
    var value = _a.value, onExit = _a.onExit, onInternalChange = _a.onInternalChange, placeholder = _a.placeholder, saveButtonText = _a.saveButtonText, saveOnExit = _a.saveOnExit, type = _a.type, validation = _a.validation, icon = _a.icon, editModeIcon = _a.editModeIcon;
    var _b = React.useState(""), inputValue = _b[0], setInputValue = _b[1];
    var _c = React.useState(), validationResults = _c[0], setValidationResults = _c[1];
    var containerRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var isValid = !validationResults ||
        validationResults.every(function (v) { return (typeof v === "boolean" ? v : v.isValid); });
    var iconDisplay = editModeIcon || icon;
    var validate = function (val) {
        if (validation !== undefined) {
            var validators = validation instanceof Array ? validation : [validation];
            setValidationResults(validators.map(function (validator) { return validator(val); }));
        }
        else {
            setValidationResults(undefined);
        }
    };
    var save = function () { return onExit(inputValue); };
    var exit = function () { return onExit(); };
    var onInputKeyDown = function (event) {
        if (event.key === "Enter" && isValid) {
            save();
        }
    };
    var onInputChange = function (event) {
        setInputValue(event.target.value);
        validate(event.target.value);
        if (onInternalChange) {
            onInternalChange(event);
        }
    };
    (0, hooks_1.useActionOutsideElement)(containerRef, function (isOutside) {
        if (isOutside) {
            if (saveOnExit && isValid) {
                save();
            }
            else {
                exit();
            }
        }
    });
    React.useEffect(function () {
        var newVal = value || "";
        setInputValue(newVal);
        if (inputRef.current) {
            inputRef.current.select();
        }
        validate(newVal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    return (React.createElement("div", { ref: containerRef, className: "gk-in-place-input-modifying" },
        React.createElement(components_1.GKFormGroup, { className: "mb-0" },
            React.createElement(components_1.GKInputGroup, null,
                React.createElement(components_1.GKInput, { type: type, placeholder: placeholder, value: inputValue, onChange: onInputChange, onKeyDown: onInputKeyDown, innerRef: inputRef, invalid: !isValid, valid: validation !== undefined && isValid }),
                iconDisplay && (React.createElement(components_1.GKInputGroupAddon, { addonType: "append" },
                    React.createElement(components_1.GKInputGroupText, null,
                        React.createElement(components_1.GKIcon, { name: iconDisplay })))),
                !saveOnExit && (React.createElement(components_1.GKButton, { color: "primary", outline: true, onClick: save, disabled: !isValid }, saveButtonText || "Save"))),
            getFeedbackFor(validationResults))));
};
exports.EditModeTemplate = EditModeTemplate;
